import { UserRole } from '@ferty9/constants';
import { Permission } from './permissions.js';

export interface JwtUserPayload {
  id: string;
  username: string;
  center_name: string;
  display_name?: string | null;
  first_name?: string | null;
  middle_name?: string | null;
  last_name?: string | null;
  phone_number?: string | null;
  is_superadmin: boolean;
  role: UserRole | string | null;
  role_name?: string | null;
  role_color_hex?: string | null;
  role_color_rgba?: string | null;
  role_color_text?: string | null;
  password_reset_required?: boolean;
  session_version?: number;
  roles?: string[];
  permissions?: Permission[];
  /** Server-resolved registered module actions; never normalised into core permissions. */
  modulePermissions?: string[];
  modulePortalAccess?: boolean;
  centerAccess?: string[];
  isRootAdmin?: boolean;
}

export const ACCESS_TOKEN_EXPIRES_IN = '12h';
